import { useErrorScreenContext } from 'context/error/error';

export function useHandleRhinoRefetch(refetch: () => Promise<void>) {
  const errorScreenContext = useErrorScreenContext();

  return async () => {
    try {
      await refetch();
      errorScreenContext.clearError();
      return true;
    } catch {
      return false; // Refetch failed
    }
  };
}
